import {remote} from '../constants/environment';
import {IPasswordRecover} from '../interfaces/dtos';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postRecoverPassword = async (
  payload: IPasswordRecover,
): Promise<IStandardServiceResponse> => {
  const remoteURI = remote.getRecoverPasswordUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify({
          payload,
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success === true) {
          return {
            success: true,
            payload: {},
          };
        } else if (data.success === false) {
          return {
            success: false,
            payload: {},
          };
        }
      }
    },
    remoteURI,
  )) as IStandardServiceResponse;
};
